module.exports = __webpack_public_path__ + "img/dlph.f40d979a.jpg";